import React, { Component } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";
import Select from 'react-select';

import { CustomCard } from "../../components/Card/CustomCard";

import Reinscripcion from "./ReinscripcionesContent/Reinscripcion";
import Inscritos from "./ReinscripcionesContent/Inscritos";
import ListCarrera from "./ReinscripcionesContent/ListCarrera";


class Reinscripciones extends Component {
    state = {
        valorActividad: { value: 'reinscripcion', label: 'Reinscripción' },
    }

    Selecciona = (link) => {
        switch (link) {
            case "/reincripciones/reinscripcion":
                return({ value: 'reinscripcion', label: 'Reinscripción' })
            case "/reincripciones/inscritos":
                return({ value: 'inscritos', label: 'Alumnos por Sección' })
            case "/reincripciones/inscritos_carrera":
                return({ value: 'inscritos_carrera', label: 'Alumnos por Carrera' })
            default:
                return({ value: 'reinscripcion', label: 'Reinscripción' })
        }
    }

    valorEstadosLabel = (link) => {
        switch (link) {
            case "/reincripciones/reinscripcion": return('Reinscripción')
            case "/reincripciones/inscritos": return('Alumnos por Sección')
            case "/reincripciones/inscritos_carrera": return('Alumnos por Carrera')
            default: return('Reinscripción')
        }
    }

    valorActividad = (valorActividad) => {
        this.setState({
            valorActividad
        },() => {
            this.props.history.push(`/reincripciones/${this.state.valorActividad.value}`);
        });
    }

    contenido = () => {
        return (
            <Switch>
                <Route path="/reincripciones/reinscripcion" component={ () => <Reinscripcion/> } />
                <Route path="/reincripciones/inscritos" component={ () => <Inscritos /> } />
                <Route path="/reincripciones/inscritos_carrera" component={ () => <ListCarrera  estCuenta = {true}/> } />
                <Redirect to = "/reincripciones/reinscripcion" />
            </Switch>
        )
    }

    render() { 
        const Opciones = [
            { value: 'reinscripcion', label: 'Reinscripción' },
            { value: 'inscritos', label: 'Alumnos por Sección' },
            { value: 'inscritos_carrera', label: 'Alumnos por Carrera' },
        ];

        return (
            <div className="content">
                <Grid fluid>
                    <div className="custom-alert-info" style={{marginBottom:15, padding:5}}>
                        <Row>
                            <Col md={9}>
                                <div className="title" style={{fontSize:14, paddingTop: 10}}>
                                    Selecciona una actividad
                                </div>
                            </Col>
                            <Col md={3}>
                                <Select
                                    isSearchable ={true}
                                    value={this.Selecciona(this.props.history.location.pathname)}
                                    onChange={this.valorActividad}
                                    options={Opciones}
                                />
                            </Col>
                        </Row>
                    </div>
                    <Row>
                        <Col md={12}>
                            <CustomCard
                                title={`${this.valorEstadosLabel(this.props.history.location.pathname)}`}
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}
 
export default Reinscripciones;


// WEBPACK FOOTER //
// ./src/views/Administracion/Reinscripciones.jsx